import React, { useRef, useEffect, useState } from 'react';

interface OutsideClickTrackerProps {
    render: (
        open: boolean,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        setOverlayOpen?: (open: boolean) => void,
    ) => React.ReactNode;
    setOverlayOpen?: (open: boolean) => void;
}

export const OutsideClickTracker: React.FC<OutsideClickTrackerProps> = ({ render, setOverlayOpen }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setOpen(false);
                setOverlayOpen && setOverlayOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside, true);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [setOverlayOpen]);

    return <div ref={wrapperRef}>{render(open, setOpen, setOverlayOpen)}</div>;
};
